import React, { FC } from 'react';
import { LinksStrings } from '../../strings/links.strings';
import { Link } from '@getgo/chameleon-web/react';
import { useTranslation } from 'react-i18next';
import './styles/footer.scss';
import { useUserContext } from '../context/userContext';

const Footer: FC = () => {
  const { t, i18n } = useTranslation();
  const { userDetail } = useUserContext();

  return (
    <footer className={`footer ${!userDetail ? 'footer-shift-up' : null}`}>
      <section>
        <p>{t('footer.copyright')}</p>
        <p>
          {t('footer.viewPolicy')}
          <Link href={LinksStrings.goToWebinarPrivacyPolicy(i18n.language)} target="_blank">
            {t('footer.policy')}
          </Link>
        </p>
        <p>{t('footer.reviewPolicy')}</p>
        <p>{t('footer.safeguarding')}</p>
      </section>
    </footer>
  );
};

export default Footer;
